"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var createRange_1 = require("../selection/createRange");
var Position_1 = require("../selection/Position");
var getLeafSibling_1 = require("../utils/getLeafSibling");
/**
 * Get the selection range in the given region.
 * The original range can cover multiple regions, this function will narrow the original selection
 * of a region into current region
 * @param regionBase The region to get range from
 */
function getSelectionRangeInRegion(regionBase) {
    if (!regionBase) {
        return null;
    }
    var nodeBefore = regionBase.nodeBefore, nodeAfter = regionBase.nodeAfter, rootNode = regionBase.rootNode, skipTags = regionBase.skipTags;
    var startNode = nodeBefore
        ? (0, getLeafSibling_1.getNextLeafSibling)(regionBase.rootNode, nodeBefore, regionBase.skipTags)
        : rootNode.firstChild;
    var endNode = nodeAfter
        ? (0, getLeafSibling_1.getPreviousLeafSibling)(rootNode, nodeAfter, skipTags)
        : rootNode.lastChild;
    var regionRange = startNode && endNode && (0, createRange_1.default)(startNode, endNode);
    if (!isRegion(regionBase)) {
        return regionRange;
    }
    else if (regionRange) {
        var regionStart = Position_1.default.getStart(regionRange).normalize();
        var regionEnd = Position_1.default.getEnd(regionRange).normalize();
        var fullSelectionEnd = regionBase.fullSelectionEnd, fullSelectionStart = regionBase.fullSelectionStart;
        if (!fullSelectionStart.isAfter(regionEnd) && !regionStart.isAfter(fullSelectionEnd)) {
            var start = fullSelectionStart.isAfter(regionStart)
                ? fullSelectionStart
                : regionStart;
            var end = fullSelectionEnd.isAfter(regionEnd) ? regionEnd : fullSelectionEnd;
            return (0, createRange_1.default)(start, end);
        }
    }
    return null;
}
exports.default = getSelectionRangeInRegion;
function isRegion(regionBase) {
    var region = regionBase;
    return !!region.fullSelectionEnd && !!region.fullSelectionStart;
}
//# sourceMappingURL=getSelectionRangeInRegion.js.map